import React from 'react';


const Banner = ({pageData = {}, settings={}}) => (
    pageData.occasion_text ?
        <div className="btn btn-lg bg-white font-32 text-blue position-relative body-size mt-3">
            <div className="p-1" style={{whiteSpace: 'pre-line'}}>
                {pageData.occasion_text && pageData.occasion_text}
            </div>
        </div>
        : <div></div>
    
)
export default Banner;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/Banner.js